<ng-container *ngIf="mobileStatus$ | async as mobileStatus">
   <fa-icon
      kendoTooltip
      [title]="mobileStatus?.mobileStatus.translationKey | translate"
      [ngClass]="mobileStatus.mobileStatus.styleClass"
      [icon]="mobileStatus.mobileStatus.statusIcon"
      [fixedWidth]="fixedWidth"
   ></fa-icon>
   <ng-container *ngIf="mobileStatus.mobileStatus.displayTextDefault">
      <span style="margin-left: 0.35em">{{ mobileStatus?.mobileStatus.translationKey | translate }}</span>
   </ng-container>
</ng-container>
<ng-container *ngIf="!(mobileStatus$ | async) as mobileStatus">
   <fa-icon
      kendoTooltip
      [title]="mobileStatus?.mobileStatus.translationKey | translate"
      [ngClass]="mobileStatus.mobileStatus.styleClass"
      [icon]="mobileStatus.mobileStatus.statusIcon"
      [fixedWidth]="fixedWidth"
   ></fa-icon>
</ng-container>
